/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/Name"
  
}) {
let userVaxiomPersonValueData = fromData.useDataFormat({ viewPath,
context: 'user',
path: 'vaxiom_person',
format: fromFormat.patientNameFull,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 data="user.vaxiom_person"
 format="/Data/format.js patientNameFull"
 text={userVaxiomPersonValueData}
/>
{children}
</React.Fragment>)
}